import React from "react";

export const Input = ({
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled = false,
  label,
  type = "text",
  isInvalid = false,
  invalidMessage,
  height = "50px",
  width = "100%",
  fontSize = "14px",
  icon,
  className = "",
}) => {
  const heightValue = typeof height === 'number' ? `${height}px` : height;
  const widthValue = typeof width === 'number' ? `${width}px` : width;
  const fontSizeValue = typeof fontSize === 'number' ? `${fontSize}px` : fontSize;

  const inputStyle = {
    height: heightValue,
    width: widthValue,
    fontSize: fontSizeValue,
    backgroundColor: '#ffffff',
    border: '1px solid #e8e8e8',
    borderRadius: '5px',
    padding: icon ? '15px 15px 15px 45px' : '15px',
    color: '#282828',
    fontFamily: "'Hanken Grotesk', sans-serif",
    outline: 'none',
    transition: 'border-color 0.2s',
  };

  const labelStyle = {
    fontSize: '14px',
    color: '#282828',
    fontFamily: "'Hanken Grotesk', sans-serif",
    fontWeight: '400',
    lineHeight: '20px',
    marginBottom: '10px',
    display: 'block',
  };

  const iconContainerStyle = {
    position: 'absolute',
    left: '15px',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  };

  const containerStyle = {
    width: widthValue,
    marginBottom: '16px',
  };

  return (
    <div style={containerStyle} className={className}>
      {label && (
        <label style={labelStyle} htmlFor={name}>
          {label}
        </label>
      )}
      <div style={{ position: 'relative', width: widthValue }}>
        {icon && (
          <div style={iconContainerStyle}>
            {icon}
          </div>
        )}
        <input
          id={name}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          style={{
            ...inputStyle,
            borderColor: isInvalid ? '#dc3545' : '#e8e8e8',
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#dbbe78';
          }}
          onBlurCapture={(e) => {
            if (!isInvalid) {
              e.target.style.borderColor = '#e8e8e8';
            }
          }}
        />
      </div>
      {isInvalid && invalidMessage && (
        <p
          style={{
            color: '#dc3545',
            fontSize: '12px',
            marginTop: '5px',
            marginBottom: '0',
          }}
        >
          {invalidMessage}
        </p>
      )}
    </div>
  );
};

